// LID -> { name, phone } map for resolving WhatsApp group @mentions (raw LID
// numbers) to names/links in message rendering. Generated from the Wali export.
// Regenerate with the Wali LID resolver and redeploy to refresh — but KEEP the
// first block: those entries were added by hand from the live group rosters
// (Smith3D staff, 2026-08-26) and are not in the Wali source. The live roster
// (MessageList → lidMentions.js) is consulted before this map inside a group
// thread; this map only backs the conversation-list preview and old threads.
/* eslint-disable */
export default
{
  "143988845756664": {
    "name": "fadh",
    "phone": "60175090655"
  },
  "71021780578540": {
    "name": "Normann",
    "phone": "60135280843"
  },
  "73960125395006": {
    "name": "Smith 3D Logistic",
    "phone": "60124196318"
  },
  "38405748617304": {
    "name": "YUNG",
    "phone": "601110861911"
  },
  "76450485027017": {
    "name": "Smith3D Malaysia",
    "phone": "60103443128"
  },
  "18494145999068": {
    "name": "Nisa Intern Smith3D",
    "phone": "601119585827"
  },
  "55297821421713": {
    "name": "Luqman Intern Smith3D",
    "phone": "60177141058"
  },
  "206991704248529": {
    "name": "Alex (Smith3D)",
    "phone": "601111961893"
  },
  "261774179852371": {
    "name": "Jun",
    "phone": "601111947215"
  },
  "253381763428525": {
    "name": "Azri (Smith3D)",
    "phone": "60139103515"
  },
  "143125725061240": {
    "name": "Adam Smith3D Intern",
    "phone": "60198787709"
  },
  "60206901895330": {
    "name": "Zarif (Smith3D)",
    "phone": "60172440704"
  },
  "34608863309920": {
    "name": "+60133374841 (Smith3D)",
    "phone": "60133374841"
  },
  "183566935785488": {
    "name": "Tan Jit Ren",
    "phone": "60123179378"
  },
  "236369934827739": {
    "name": "Erwins",
    "phone": "601111857612"
  },
  "114289096523914": {
    "name": "Syafiqah Smith3D (Piqa)",
    "phone": "60139580342"
  },
  "109959769493748": {
    "name": "Acap Smith3D Intern",
    "phone": "60123137880"
  },
  "221693394047066": {
    "name": "Wan Smith3d",
    "phone": "60108874227"
  },
  "268152004952084": {
    "name": "Ammar Intern Smith3D",
    "phone": "60136936814"
  },
  "200987490938913": {
    "name": "CY",
    "phone": "60169158348"
  },
  "281015582998752": {
    "name": "Jit Hui",
    "phone": "60162871308"
  },
  "71146284265571": {
    "name": "Norman",
    "phone": "60196026435"
  },
  "3947192401937": {
    "name": "safiy",
    "phone": "60193699682"
  },
  "196370283638865": {
    "name": "3D Express",
    "phone": "601156356248"
  },
  "100073375547609": {
    "name": "3dexpress.my Supply Chain Force",
    "phone": "60187654980"
  },
  "15668091031764": {
    "name": "KahYin",
    "phone": "60105436992"
  },
  "265932060549327": {
    "name": "3DExpress.my",
    "phone": "60187654398"
  },
  "271162793820301": {
    "name": "Rainie",
    "phone": "60172003314"
  },
  "201210711773203": {
    "name": "Kelvin Morphlab",
    "phone": "60126080537"
  },
  "111931276931219": {
    "name": "Bruce Lee",
    "phone": "60126969599"
  },
  "131361625137340": {
    "name": "Ts. Zulhazreen",
    "phone": "601136653221"
  },
  "66709566259304": {
    "name": "Bruce Mui",
    "phone": "601111121821"
  },
  "28441776791750": {
    "name": "Oliver",
    "phone": "60102450618"
  },
  "80393516667006": {
    "name": "Positive Yield Service Centre",
    "phone": "60146752268"
  },
  "111828214493315": {
    "name": "SK Lein",
    "phone": "60196773388"
  },
  "178756840894591": {
    "name": "Max",
    "phone": "60102798350"
  },
  "100309028368473": {
    "name": "Tomo",
    "phone": "601155076829"
  },
  "101309755695154": {
    "name": "aqil",
    "phone": "601139690913"
  },
  "101691957489822": {
    "name": "Ashok",
    "phone": "601151688422"
  },
  "102800444944626": {
    "name": "SamS",
    "phone": "60172179602"
  },
  "104191762657299": {
    "name": "Gine Wong",
    "phone": "60162620302"
  },
  "105140916904135": {
    "name": "M.Sahrul Mizam",
    "phone": "60132477390"
  },
  "105196650819689": {
    "name": "Lynn Anuar",
    "phone": "60184747808"
  },
  "105737833447584": {
    "name": "Wong Siew Chin",
    "phone": "60163383181"
  },
  "106206068736175": {
    "name": "Hong",
    "phone": "60163166949"
  },
  "106545354416194": {
    "name": "brandon🙈",
    "phone": "60122448453"
  },
  "106721481609421": {
    "name": "Ming Yeng",
    "phone": "60179799980"
  },
  "107580441522310": {
    "name": "Yang.",
    "phone": "60189568468"
  },
  "107760796573779": {
    "name": "Junnu",
    "phone": "9609319786"
  },
  "108864603181220": {
    "name": "Kenneth~",
    "phone": "60163459066"
  },
  "109861069172905": {
    "name": "Adly",
    "phone": "601162861506"
  },
  "109981277896869": {
    "name": "Ameera Batrysya",
    "phone": "60142342908"
  },
  "11330274762782": {
    "name": "Rynn",
    "phone": "60182714423"
  },
  "113335664115825": {
    "name": "Lucas",
    "phone": "6590583228"
  },
  "113400038322184": {
    "name": "Shawn",
    "phone": "60172881084"
  },
  "113447450742832": {
    "name": "Vincent Hoy",
    "phone": "60162863459"
  },
  "115672227045500": {
    "name": "Arvin Kumar Asogan",
    "phone": "60147167621"
  },
  "116715853746347": {
    "name": "Waimun",
    "phone": "60162456162"
  },
  "117102417563892": {
    "name": "Calvin Chong",
    "phone": "60176838713"
  },
  "117265576018168": {
    "name": "Faril",
    "phone": "60122304096"
  },
  "11768394977504": {
    "name": "Suriati Samsuri",
    "phone": "60127624007"
  },
  "117690761003197": {
    "name": "Joyce Tan",
    "phone": "60164227061"
  },
  "117845665030342": {
    "name": "Syed Azaudin",
    "phone": "601155500062"
  },
  "119189788479686": {
    "name": "Leon Teh",
    "phone": "60166393028"
  },
  "119438812668012": {
    "name": "Iman",
    "phone": "601169787159"
  },
  "119593532133503": {
    "name": "Euro Tech Motorworks PLT",
    "phone": "60162228428"
  },
  "119679465037891": {
    "name": "Fiekri",
    "phone": "60166343346"
  },
  "11983092977668": {
    "name": "Jack Lee",
    "phone": "60147593418"
  },
  "120512520974560": {
    "name": "Steevee",
    "phone": "60174310492"
  },
  "120598554484989": {
    "name": "Miey",
    "phone": "60103833091"
  },
  "121161144889440": {
    "name": "Naga",
    "phone": "601123569102"
  },
  "122363953864945": {
    "name": "~shazasariff✌️~",
    "phone": "60126579753"
  },
  "122861901602868": {
    "name": "Jakaya",
    "phone": "60169165865"
  },
  "123291347996706": {
    "name": "Rizal Afif",
    "phone": "601110041701"
  },
  "123467592630328": {
    "name": "RocknRolla",
    "phone": "60173651051"
  },
  "123480494350495": {
    "name": "Farah Fariza",
    "phone": "60129385940"
  },
  "123789698416805": {
    "name": "Ali Zainal Dato’ Muhamed",
    "phone": "60139860424"
  },
  "124055902548159": {
    "name": "Lee Kean Seng",
    "phone": "60162663034"
  },
  "125005174186080": {
    "name": "Khairul Nizam",
    "phone": "601110204204"
  },
  "125430359187567": {
    "name": "Jaery C",
    "phone": "60162303882"
  },
  "126289235177675": {
    "name": "Ronit",
    "phone": "601123342848"
  },
  "127049578635324": {
    "name": "Jerry  Thoo",
    "phone": "60196990283"
  },
  "127909075390579": {
    "name": "Archi Studio",
    "phone": "60106648053"
  },
  "128226366124260": {
    "name": "Jaymee ☆",
    "phone": "601139406984"
  },
  "128574258458661": {
    "name": "Azwan AS 😎",
    "phone": "60123447855"
  },
  "128840546418874": {
    "name": "shallyyyyy",
    "phone": "60178229706"
  },
  "129021002182909": {
    "name": "FraNz",
    "phone": "60183161188"
  },
  "129106901495828": {
    "name": "Nandhini Karmehen",
    "phone": "60166650918"
  },
  "129880465379430": {
    "name": "Marwah Talukder",
    "phone": "601128846142"
  },
  "132804885106822": {
    "name": "yewsoong09",
    "phone": "60173072519"
  },
  "133066710372594": {
    "name": "Mrs_Syaffiq",
    "phone": "60133204713"
  },
  "133075384176753": {
    "name": "Darrel Cheong (Kamaboko)",
    "phone": "60102925172"
  },
  "134260811939877": {
    "name": "Edmund 周轩丞 👑",
    "phone": "60126069927"
  },
  "134406907949104": {
    "name": "shaf11z",
    "phone": "60163398097"
  },
  "13589712752804": {
    "name": "Hakim",
    "phone": "60102506847"
  },
  "136137645535477": {
    "name": "Ken",
    "phone": "60179324750"
  },
  "13679588323444": {
    "name": "Keatz",
    "phone": "60126048608"
  },
  "137117166530785": {
    "name": "Nurul Atiqah",
    "phone": "601110040102"
  },
  "137318862213291": {
    "name": "Janice",
    "phone": "60164618592"
  },
  "138469762433147": {
    "name": "Aqeef Rasyid",
    "phone": "601165071001"
  },
  "139878528483341": {
    "name": "syaznelaiman:)",
    "phone": "60196450816"
  },
  "139951693942844": {
    "name": "ABHI CHAUHAN",
    "phone": "447384256649"
  },
  "14044626997314": {
    "name": "欣",
    "phone": "60105646733"
  },
  "141922932936862": {
    "name": "KSL",
    "phone": "60122167211"
  },
  "142116189692137": {
    "name": "Bryan LEW",
    "phone": "60123590715"
  },
  "143353224114311": {
    "name": "Crazee Nar",
    "phone": "601137791909"
  },
  "144663189156013": {
    "name": "Liza",
    "phone": "60126267657"
  },
  "144676090867735": {
    "name": "Cathy Chan",
    "phone": "601123220155"
  },
  "145148470153449": {
    "name": "Mohamad Shariff_ShahBoyz😆",
    "phone": "60135808029"
  },
  "145900173262890": {
    "name": "Ray`Alan",
    "phone": "60163564199"
  },
  "145939163537529": {
    "name": "Atirah",
    "phone": "601175030412"
  },
  "146166394142773": {
    "name": "Daniel Lu",
    "phone": "60178128824"
  },
  "146192247836920": {
    "name": "Celine Lai",
    "phone": "60168133953"
  },
  "147158833598620": {
    "name": "Lee Ting Sheng",
    "phone": "60122874792"
  },
  "150354356338798": {
    "name": "iqbal",
    "phone": "60103791340"
  },
  "150826685309023": {
    "name": "Ahmad Basir Mohamed",
    "phone": "60145437254"
  },
  "152956771029094": {
    "name": "Yu Wen",
    "phone": "601110726587"
  },
  "154906652581901": {
    "name": "Ben",
    "phone": "60162081817"
  },
  "155039880503529": {
    "name": "Tajul Aisyahri",
    "phone": "60143393811"
  },
  "155190120476710": {
    "name": "Azrul",
    "phone": "601116205696"
  },
  "155602990969052": {
    "name": "Nirmana",
    "phone": "601164949514"
  },
  "155649698721798": {
    "name": "Reuben",
    "phone": "60125923110"
  },
  "156040658215118": {
    "name": "Awie",
    "phone": "60129807702"
  },
  "156530183807219": {
    "name": "Nizzal Syafiq",
    "phone": "60193054877"
  },
  "15681428951181": {
    "name": "Kk Chong",
    "phone": "601113199144"
  },
  "157183035617361": {
    "name": "Irfan Sharil",
    "phone": "60193708430"
  },
  "15814203822133": {
    "name": "fairus",
    "phone": "60125980858"
  },
  "158802171154671": {
    "name": "Yap Jang Sheng",
    "phone": "60126469971"
  },
  "159235962834981": {
    "name": "MR",
    "phone": "60178728069"
  },
  "160322908365006": {
    "name": "Yuumi",
    "phone": "66814563148"
  },
  "162028077510706": {
    "name": "KHAIRIL",
    "phone": "60199711043"
  },
  "162770871922897": {
    "name": "Amy Rahim",
    "phone": "60132224699"
  },
  "163075663650901": {
    "name": "Sern",
    "phone": "60126660386"
  },
  "163367788507155": {
    "name": "shidatulathirah",
    "phone": "60132771299"
  },
  "165068629106800": {
    "name": "Au",
    "phone": "60182904275"
  },
  "165665746997434": {
    "name": "DhiYau🐯",
    "phone": "601137484277"
  },
  "166065044717802": {
    "name": "Bernard",
    "phone": "60163389068"
  },
  "166095596056716": {
    "name": "asnikas",
    "phone": "601129382810"
  },
  "168203837776113": {
    "name": "Peng Bukan Nama Sebenar",
    "phone": "60132082087"
  },
  "169007097336002": {
    "name": "Azwani Erwan",
    "phone": "60139030830"
  },
  "170093673758724": {
    "name": "Pengejar Impian😘",
    "phone": "60133863829"
  },
  "171386408587305": {
    "name": "zakwan_desu",
    "phone": "60195592113"
  },
  "171425835012293": {
    "name": "Yuzu",
    "phone": "60174200830"
  },
  "171614192799921": {
    "name": "Tommy Lee",
    "phone": "60123206586"
  },
  "17197099384838": {
    "name": "Nayliulfasalwaraed",
    "phone": "60196144355"
  },
  "172254025494709": {
    "name": "Iqbal.eth",
    "phone": "601116959459"
  },
  "172319104360529": {
    "name": "AL",
    "phone": "601154416689"
  },
  "173079313551576": {
    "name": "weiboxuan36",
    "phone": "6588465029"
  },
  "173413717016620": {
    "name": "A.Raqim",
    "phone": "60182020021"
  },
  "175514039939127": {
    "name": "alvinloh73",
    "phone": "60165002925"
  },
  "175745917800522": {
    "name": "chinkm8",
    "phone": "60175131813"
  },
  "17579485720593": {
    "name": "Eric Lim Yong Khang",
    "phone": "60164290969"
  },
  "176274181996571": {
    "name": "JR",
    "phone": "6598525220"
  },
  "176677925699818": {
    "name": "Zachary Lee",
    "phone": "60123622340"
  },
  "177682864201865": {
    "name": "Syazril_eL",
    "phone": "60164863489"
  },
  "178593883750512": {
    "name": "Ch£w HW 💼",
    "phone": "60109144308"
  },
  "179448112517315": {
    "name": "Done",
    "phone": "6597962089"
  },
  "1795329884263": {
    "name": "Ian Hoh",
    "phone": "60174036388"
  },
  "179658649792664": {
    "name": "Jacky Chong",
    "phone": "60123027203"
  },
  "180367235498006": {
    "name": "AslamHadi",
    "phone": "60189151470"
  },
  "181024331943971": {
    "name": "Jai Ismail",
    "phone": "60123637253"
  },
  "181346454499512": {
    "name": "LCT",
    "phone": "60123706650"
  },
  "181397943763074": {
    "name": "M.Fikri.H",
    "phone": "601123204874"
  },
  "181690135789583": {
    "name": "Afiq Farhan",
    "phone": "601121561242"
  },
  "182175517409310": {
    "name": "Hakim",
    "phone": "60172488744"
  },
  "182226922782880": {
    "name": "Jegan",
    "phone": "60195153019"
  },
  "183339386441957": {
    "name": "Dk",
    "phone": "60189724311"
  },
  "184306072858674": {
    "name": "hazril shopee",
    "phone": "60123326947"
  },
  "186547659911385": {
    "name": "Fadhil",
    "phone": "60175261842"
  },
  "187479667777678": {
    "name": "TIONG (FANUC MECHATRONICS MALAYSIA SDN BHD)",
    "phone": "60122980641"
  },
  "187509816439005": {
    "name": "Ivan Low",
    "phone": "60127327748"
  },
  "188025212547307": {
    "name": "Kean",
    "phone": "60178126308"
  },
  "188257174311119": {
    "name": "miashasha",
    "phone": "601155531407"
  },
  "188690882142336": {
    "name": "faiz5595",
    "phone": "60164297164"
  },
  "189266407739570": {
    "name": "Ujang",
    "phone": "60123109897"
  },
  "189558599717108": {
    "name": "😈Suriya Mahendran😈",
    "phone": "601128673567"
  },
  "190396017705210": {
    "name": "Zhun Ming",
    "phone": "60162357996"
  },
  "190748171456520": {
    "name": "Siti Nadia 😊",
    "phone": "60132835576"
  },
  "191147670523989": {
    "name": "YU HENG",
    "phone": "60124317753"
  },
  "191791865290843": {
    "name": "AlangAdzim",
    "phone": "60145327904"
  },
  "192569321455733": {
    "name": "Winx🐱",
    "phone": "60149084076"
  },
  "194360222200017": {
    "name": "Hasanudin Zakuwan",
    "phone": "60194191490"
  },
  "194519169499242": {
    "name": "Hooi Ming",
    "phone": "60164683768"
  },
  "196649439744171": {
    "name": "Daphny Wong",
    "phone": "60163929861"
  },
  "196898614984846": {
    "name": "ALICE LEW",
    "phone": "601111511540"
  },
  "197658840924275": {
    "name": "Ts Khairul Fadzli",
    "phone": "60192189925"
  },
  "198105500790935": {
    "name": "amysia",
    "phone": "60197292377"
  },
  "199497137258736": {
    "name": "Amir",
    "phone": "601123072316"
  },
  "201893678706927": {
    "name": "Wai Leon👍",
    "phone": "60162169796"
  },
  "202898650714282": {
    "name": "Eric Gan",
    "phone": "60122939529"
  },
  "203525682372735": {
    "name": "Raphael",
    "phone": "6596325095"
  },
  "20418375217281": {
    "name": "DR JC🧐",
    "phone": "60126575917"
  },
  "204917352443961": {
    "name": "Zufadlee Lias",
    "phone": "60139610692"
  },
  "205145019297958": {
    "name": "Mizan Zaini",
    "phone": "6738309295"
  },
  "205862111027297": {
    "name": "👻 AdRiAn 👻",
    "phone": "60189663263"
  },
  "20594384965749": {
    "name": "K C Saw",
    "phone": "60173331868"
  },
  "206240084938776": {
    "name": "Ly",
    "phone": "60143506002"
  },
  "207812110078062": {
    "name": "Doo-OH Monkeys",
    "phone": "60196471560"
  },
  "207880879866052": {
    "name": "tiger teeth 🐯",
    "phone": "601151926246"
  },
  "208946065342540": {
    "name": "Krishna R.J.",
    "phone": "60123483047"
  },
  "210878666379420": {
    "name": "LIL",
    "phone": "60192288832"
  },
  "211372906422289": {
    "name": "Skyprint",
    "phone": "60127062962"
  },
  "212588080140496": {
    "name": "Peng",
    "phone": "60103977089"
  },
  "212867303370884": {
    "name": "Zan",
    "phone": "60137743099"
  },
  "212970349060160": {
    "name": "Jing Yee",
    "phone": "60129871183"
  },
  "213150687322224": {
    "name": "Nulvin",
    "phone": "23059070203"
  },
  "213378454839531": {
    "name": "Brian",
    "phone": "60163226689"
  },
  "21449284804628": {
    "name": "Muhamad Noor Mohamed",
    "phone": "60123436213"
  },
  "215006247399432": {
    "name": "Firadaus",
    "phone": "60134066660"
  },
  "21616754966726": {
    "name": "123mathlab",
    "phone": "60163789729"
  },
  "216191557734428": {
    "name": "Ts. Wan Mohd Azlan",
    "phone": "60199905736"
  },
  "216874491109387": {
    "name": "Chye Boon",
    "phone": "60146280667"
  },
  "217578815410276": {
    "name": "Eugene",
    "phone": "60169337963"
  },
  "217639028826172": {
    "name": "Kamarul Muhamed",
    "phone": "60139808998"
  },
  "217777122054391": {
    "name": "Hafiz",
    "phone": "601128399936"
  },
  "217973918855251": {
    "name": "Firdaus",
    "phone": "601121898489"
  },
  "220057011544139": {
    "name": "Kong",
    "phone": "60165601128"
  },
  "22059052703747": {
    "name": "Alwin",
    "phone": "60122029226"
  },
  "221659051106341": {
    "name": "TAN CHEH WEI",
    "phone": "60129639633"
  },
  "22179328561342": {
    "name": "KA",
    "phone": "60182344551"
  },
  "221981207179310": {
    "name": "ムハンマドダニアル",
    "phone": "60173546187"
  },
  "22213939978336": {
    "name": "pizie",
    "phone": "60129395631"
  },
  "223608932663512": {
    "name": "thaiyit",
    "phone": "60163838947"
  },
  "223815191789644": {
    "name": "DakNurul",
    "phone": "60126196043"
  },
  "224120184827926": {
    "name": "kebudayaan",
    "phone": "601139744566"
  },
  "224128791531726": {
    "name": "Jay Ikmal",
    "phone": "60145062078"
  },
  "225099286315064": {
    "name": "rizduan anuar",
    "phone": "601161387902"
  },
  "226198797951167": {
    "name": "Mandy Chan",
    "phone": "60182373289"
  },
  "227727789559935": {
    "name": "Muhammad Zulkifly",
    "phone": "60123772742"
  },
  "228346348761205": {
    "name": "Brian M",
    "phone": "60122196719"
  },
  "229011968004208": {
    "name": "ck",
    "phone": "601123269910"
  },
  "229248392519925": {
    "name": "Brian lee Shyue shin",
    "phone": "60129069113"
  },
  "229828162781307": {
    "name": "Vip Tailor",
    "phone": "60175514978"
  },
  "231296924184601": {
    "name": "Ray Lim",
    "phone": "601135404966"
  },
  "232207943766098": {
    "name": "ADMIN PL GARDEN",
    "phone": "60125123825"
  },
  "233075040624713": {
    "name": "Leong6",
    "phone": "60163132000"
  },
  "233264069521616": {
    "name": "Sam Chia",
    "phone": "60162131760"
  },
  "234221863985232": {
    "name": "Afiq Nazmi",
    "phone": "60173008790"
  },
  "234552509354135": {
    "name": "WanShaharudin",
    "phone": "60129062315"
  },
  "236747304788223": {
    "name": "Kevin",
    "phone": "60146362792"
  },
  "237455873728599": {
    "name": "Kavin",
    "phone": "60174650015"
  },
  "238306830889123": {
    "name": "A",
    "phone": "601121728344"
  },
  "238916263272635": {
    "name": "Rosslifumi",
    "phone": "60139806216"
  },
  "239302810271766": {
    "name": "mohamadfaisol82",
    "phone": "60176910504"
  },
  "240045738950887": {
    "name": "Gold Subra",
    "phone": "60133823939"
  },
  "240333652783323": {
    "name": "Mikky Tan",
    "phone": "601111467556"
  },
  "241020881096721": {
    "name": "Jason",
    "phone": "60122595433"
  },
  "242515378729181": {
    "name": "Yong Ket Leong",
    "phone": "60172292688"
  },
  "242532659290174": {
    "name": "Vincent Yip",
    "phone": "60165105910"
  },
  "242743112638659": {
    "name": "Qh",
    "phone": "60129143703"
  },
  "243022335844535": {
    "name": "KARTHIK",
    "phone": "60165854680"
  },
  "243842607538386": {
    "name": "Chiew Thin Tzee 7120",
    "phone": "60108406465"
  },
  "244508310642940": {
    "name": "Hariz Farhan",
    "phone": "60133260398"
  },
  "244894908055603": {
    "name": "Amru Najmi Osman",
    "phone": "60133800888"
  },
  "245084272496865": {
    "name": "Chan May Ti (Tina)",
    "phone": "60186669780"
  },
  "245139654107225": {
    "name": "Abdullah",
    "phone": "60173969197"
  },
  "245603544096816": {
    "name": "Zairi",
    "phone": "60193135707"
  },
  "245667851165807": {
    "name": "Aravindra Murugan",
    "phone": "60166707404"
  },
  "246135985840352": {
    "name": "SP",
    "phone": "6598504163"
  },
  "246286326489253": {
    "name": ".",
    "phone": "60137543128"
  },
  "248799100444674": {
    "name": "De Valda’s chalet",
    "phone": "60176664796"
  },
  "250212094374017": {
    "name": "Workingclasszero",
    "phone": "60162120101"
  },
  "250302171242675": {
    "name": "Henry",
    "phone": "60165259723"
  },
  "251457467105316": {
    "name": "Azmin USM",
    "phone": "60134402004"
  },
  "25151378866330": {
    "name": "Amy Teng",
    "phone": "60163816514"
  },
  "252583369265349": {
    "name": "Gan Sze Ann",
    "phone": "60102328370"
  },
  "252973590565018": {
    "name": "Eng.Yousef Gamal",
    "phone": "60182174904"
  },
  "253205619425480": {
    "name": "Logen",
    "phone": "60172302096"
  },
  "253300175814695": {
    "name": "Irfan Majid",
    "phone": "60173293642"
  },
  "254317948878862": {
    "name": "Badrul",
    "phone": "60104060730"
  },
  "254485519667354": {
    "name": "Muhamad Johar",
    "phone": "60173374051"
  },
  "254897870090378": {
    "name": "abidahshukri",
    "phone": "601159191291"
  },
  "255627913900171": {
    "name": "Asyikin",
    "phone": "60126718784"
  },
  "256980811784288": {
    "name": "Zhi Hao Looi",
    "phone": "60165272633"
  },
  "258312234921998": {
    "name": "Plexcom Network System",
    "phone": "60164416686"
  },
  "259304422658057": {
    "name": "Gone",
    "phone": "60197355108"
  },
  "260116288901331": {
    "name": "Nurul Najihah",
    "phone": "60145328479"
  },
  "261241452912675": {
    "name": "Nixon The Kidd",
    "phone": "601125731773"
  },
  "261336260976880": {
    "name": "Ayaan",
    "phone": "9609975787"
  },
  "261829880246396": {
    "name": "How",
    "phone": "60138627662"
  },
  "261877175169107": {
    "name": "ejai",
    "phone": "60132041103"
  },
  "262276523286763": {
    "name": "chinchuan86",
    "phone": "60172500891"
  },
  "263754159755332": {
    "name": "Flow Studios",
    "phone": "60146505432"
  },
  "264239574954157": {
    "name": "Risdian Shah",
    "phone": "60177306134"
  },
  "265506439360568": {
    "name": "Kennichiwa",
    "phone": "60186651014"
  },
  "265944425320542": {
    "name": "Edwin",
    "phone": "60125761027"
  },
  "267825721655542": {
    "name": "Anas",
    "phone": "60125505044"
  },
  "270059037523977": {
    "name": "Ben Ong",
    "phone": "60173272350"
  },
  "27084097347730": {
    "name": "munakhlid",
    "phone": "60197361217"
  },
  "27131492986977": {
    "name": "Chailing彩灵",
    "phone": "60164158489"
  },
  "271673894940802": {
    "name": "Joshua A Robert",
    "phone": "60164540498"
  },
  "272382547730579": {
    "name": "Chris Little",
    "phone": "60185798296"
  },
  "273014075719852": {
    "name": "Hazirul Haqim",
    "phone": "601119972885"
  },
  "273705448005880": {
    "name": "Khair Nafis",
    "phone": "60176126416"
  },
  "273890148360396": {
    "name": "Theng",
    "phone": "60126696536"
  },
  "274057769541681": {
    "name": "FRI",
    "phone": "60195990074"
  },
  "275552401391732": {
    "name": "AV",
    "phone": "60172881580"
  },
  "277154877165601": {
    "name": "Three D Custom Trophy",
    "phone": "60178633671"
  },
  "27827143475220": {
    "name": "Aaron | Compathree Films",
    "phone": "60122897500"
  },
  "2783726043309": {
    "name": "وان",
    "phone": "60179632184"
  },
  "278889590964266": {
    "name": "fr.",
    "phone": "601161465758"
  },
  "279142943727620": {
    "name": "Ethellim",
    "phone": "601111319913"
  },
  "279194751750325": {
    "name": "MR . K",
    "phone": "6594608572"
  },
  "280655023857714": {
    "name": "Munaim",
    "phone": "60133823474"
  },
  "281049942720743": {
    "name": "JeffCreative",
    "phone": "60174354226"
  },
  "281140086722763": {
    "name": "Suhailily",
    "phone": "60109831904"
  },
  "29275168210981": {
    "name": "op J&T",
    "phone": "60175462578"
  },
  "29605343813641": {
    "name": "Jiaquan",
    "phone": "60162599130"
  },
  "29669701206025": {
    "name": "Mukhridz",
    "phone": "60197071717"
  },
  "32041127161938": {
    "name": "D",
    "phone": "60138897716"
  },
  "32087767806016": {
    "name": "Aqilah Razali",
    "phone": "60182523273"
  },
  "32126439276710": {
    "name": "Lok Hoong Fei",
    "phone": "60163380224"
  },
  "32465724907533": {
    "name": "Amir Rasyidi Johari",
    "phone": "60122025041"
  },
  "32895557226629": {
    "name": "Duro Accounts",
    "phone": "60168814588"
  },
  "33475176476915": {
    "name": "Iman",
    "phone": "60185707394"
  },
  "34080666214538": {
    "name": "Aaron Leong",
    "phone": "601155163149"
  },
  "34269644759200": {
    "name": "Jihen Chai",
    "phone": "601155011652"
  },
  "34377035698302": {
    "name": "Eden Teoh",
    "phone": "60123228920"
  },
  "34656208568444": {
    "name": "Eddy",
    "phone": "60172631883"
  },
  "34677666664530": {
    "name": "A",
    "phone": "60192777799"
  },
  "34901088796799": {
    "name": "kintang",
    "phone": "60143651103"
  },
  "37039965761536": {
    "name": "Ninjah Grillz",
    "phone": "60104647463"
  },
  "37675553837090": {
    "name": "YgusenP",
    "phone": "60126871868"
  },
  "38341340823797": {
    "name": "Michelle",
    "phone": "60122331258"
  },
  "38367043555329": {
    "name": "Bobby Tang",
    "phone": "60186673965"
  },
  "41592496902248": {
    "name": "Azri Zain",
    "phone": "60123870430"
  },
  "41820130119804": {
    "name": "purchasepillion",
    "phone": "60124835768"
  },
  "41888849637501": {
    "name": "Malacca Arowana BIRD",
    "phone": "60178855486"
  },
  "42649092415703": {
    "name": "btdotcomtechnology",
    "phone": "60177532167"
  },
  "44010630574153": {
    "name": "hirumizabidi",
    "phone": "60123482834"
  },
  "44263966507068": {
    "name": "JosephTham",
    "phone": "60163769098"
  },
  "44405767569631": {
    "name": "NA",
    "phone": "60139807202"
  },
  "44418602131619": {
    "name": "Simon?",
    "phone": "601123251069"
  },
  "45629866778779": {
    "name": "Qawie Sobri",
    "phone": "60174010932"
  },
  "46866834137237": {
    "name": "Nes",
    "phone": "601139021007"
  },
  "47004323451089": {
    "name": "MENAGAH",
    "phone": "60109005106"
  },
  "47480930574395": {
    "name": "JD",
    "phone": "60192686268"
  },
  "47596861157443": {
    "name": "WSTan",
    "phone": "60123779660"
  },
  "51110362509312": {
    "name": "Hisyam Ahmad",
    "phone": "60183518135"
  },
  "51308333666385": {
    "name": "Emir",
    "phone": "60146245214"
  },
  "51690501836835": {
    "name": "Amali Firdaus Mildef",
    "phone": "60122135755"
  },
  "51956370399296": {
    "name": "Mogan",
    "phone": "60149444548"
  },
  "52664956112902": {
    "name": "Ricardo",
    "phone": "60123030535"
  },
  "53622901604370": {
    "name": "Dharyan",
    "phone": "60124320131"
  },
  "54073789268023": {
    "name": "Meiyen",
    "phone": "60127636282"
  },
  "55847526916297": {
    "name": "MUHAMMAD AFIQ BIN ZULKIFLI",
    "phone": "60142239194"
  },
  "5652227338288": {
    "name": "Azwin Assilah",
    "phone": "60122811290"
  },
  "56685146165332": {
    "name": "Z",
    "phone": "60193302584"
  },
  "56745124729022": {
    "name": "hjdzarifbakhari",
    "phone": "60194134114"
  },
  "58141039407242": {
    "name": "Hh",
    "phone": "60122221615"
  },
  "59631426646058": {
    "name": "nazrirasit",
    "phone": "60123961694"
  },
  "60125398233296": {
    "name": "Stevan Lee",
    "phone": "60169908272"
  },
  "60833950396428": {
    "name": "Nor Hazwani",
    "phone": "601121928055"
  },
  "61851907928137": {
    "name": "Aimran G",
    "phone": "60163129234"
  },
  "62307124129986": {
    "name": "Asser",
    "phone": "601123396439"
  },
  "64235681902639": {
    "name": "Jason",
    "phone": "60102953099"
  },
  "64235916812397": {
    "name": "Bryan",
    "phone": "60133313128"
  },
  "64789648801903": {
    "name": "DFOO",
    "phone": "60122206117"
  },
  "65631462383669": {
    "name": "Asyraf Arif",
    "phone": "60176257033"
  },
  "65859062071517": {
    "name": "p30pro3517",
    "phone": "60122091515"
  },
  "65923486625980": {
    "name": "Wilson Lim",
    "phone": "60143097300"
  },
  "670082043971": {
    "name": "Syazwan",
    "phone": "60172400172"
  },
  "67753226580199": {
    "name": "Kayden",
    "phone": "60125110854"
  },
  "68822673416370": {
    "name": "Ajmal",
    "phone": "601111452648"
  },
  "69114680881395": {
    "name": "Mi",
    "phone": "60108050039"
  },
  "71305365839944": {
    "name": "Chee Tze",
    "phone": "60149725136"
  },
  "72911532630209": {
    "name": "Leong Yeu Kao",
    "phone": "60122952381"
  },
  "73568494813426": {
    "name": "A.A",
    "phone": "60192247568"
  },
  "7378904862893": {
    "name": "Haziq",
    "phone": "60125901971"
  },
  "74328720846965": {
    "name": "Zulhakim Sanip",
    "phone": "60172080214"
  },
  "74436195676412": {
    "name": "Lily莉",
    "phone": "60127498895"
  },
  "74797006475362": {
    "name": "Mr.Nobody",
    "phone": "60195747723"
  },
  "75041735762031": {
    "name": "Mohamad Farid",
    "phone": "60166924421"
  },
  "75582901584005": {
    "name": "Jeanna Ng",
    "phone": "60187654416"
  },
  "76008237580436": {
    "name": "Muhammad Firdaus Apit",
    "phone": "601123689649"
  },
  "76321652740271": {
    "name": "Bonnie",
    "phone": "60176726811"
  },
  "76428976644204": {
    "name": "Nariman Zulkifli",
    "phone": "60173092078"
  },
  "76480684027904": {
    "name": "Chia Wei Boey",
    "phone": "60172253228"
  },
  "76987473375376": {
    "name": "Voon Yit Nan",
    "phone": "60198865399"
  },
  "77339627139270": {
    "name": "SHU SENG",
    "phone": "60168561297"
  },
  "77352545607693": {
    "name": "IT SUPPORT",
    "phone": "60182733172"
  },
  "77833430950091": {
    "name": "Name",
    "phone": "60137339982"
  },
  "78336076333075": {
    "name": "Halley",
    "phone": "60102809942"
  },
  "79040417423482": {
    "name": "Jackie Goh",
    "phone": "60143013869"
  },
  "79083232833553": {
    "name": "Mr Beast",
    "phone": "60108214737"
  },
  "81875062247599": {
    "name": "A.k",
    "phone": "60132302774"
  },
  "81991110262808": {
    "name": "Rohit",
    "phone": "601137247654"
  },
  "82115664285836": {
    "name": "Timo Ong",
    "phone": "60176551865"
  },
  "83618852548835": {
    "name": "Jacqualine Wilson",
    "phone": "60109632506"
  },
  "83889435459665": {
    "name": "Rahfizan",
    "phone": "60196897278"
  },
  "8418186244141": {
    "name": "AZAM",
    "phone": "601126467549"
  },
  "84258735562960": {
    "name": "MajAzizulKemKom10",
    "phone": "60173173890"
  },
  "84783141011671": {
    "name": "Stefan",
    "phone": "60129878340"
  },
  "85843645604085": {
    "name": "Faiz",
    "phone": "60139818751"
  },
  "87437028143274": {
    "name": "Fakhrulgc_",
    "phone": "60179013856"
  },
  "88832875704398": {
    "name": "Mei",
    "phone": "60149398578"
  },
  "88966053265620": {
    "name": "Felicia",
    "phone": "61424289088"
  },
  "89073460977856": {
    "name": "munirfaizz😎🌹🔫",
    "phone": "60174702768"
  },
  "89949583982709": {
    "name": "Tony",
    "phone": "60127409380"
  },
  "90250315612294": {
    "name": "ZAMANTECH.COM",
    "phone": "60136635337"
  },
  "9032484016231": {
    "name": "N",
    "phone": "60102905988"
  },
  "90851728474196": {
    "name": "My3dshoppe",
    "phone": "60108255722"
  },
  "91680439058673": {
    "name": "~billythekid~",
    "phone": "60192109363"
  },
  "92380468408324": {
    "name": "Wahidudin",
    "phone": "601116391237"
  },
  "92852948320271": {
    "name": "Teddyboy",
    "phone": "6598179083"
  },
  "93789486092393": {
    "name": "SW",
    "phone": "60126593905"
  },
  "94085671067903": {
    "name": "DMJ MACHINERY",
    "phone": "601110898485"
  },
  "9453374058638": {
    "name": "+60 18-956 5529",
    "phone": "60189565529"
  },
  "95339801514014": {
    "name": "Michael",
    "phone": "60127378033"
  },
  "95369782395020": {
    "name": "Hanna🌸",
    "phone": "601112600185"
  },
  "98019827576949": {
    "name": "Ts. Daniel Ganasundram",
    "phone": "601154077044"
  },
  "99132274384938": {
    "name": "Zul Farhan",
    "phone": "601116324642"
  },
  "99389938901052": {
    "name": "Avi",
    "phone": "60176487223"
  },
  "99488706351294": {
    "name": "Azmal Aizzat",
    "phone": "60126847120"
  },
  "9968652689654": {
    "name": "Dylan Yeong",
    "phone": "60176683128"
  }
}
;
